
import React, { FC, useState } from "react";
import { Helmet } from "react-helmet";
import Input from "shared/Input/Input";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useLoginClientMutation, useRegisterClientMutation } from "application/features/clientAuth/authClientApiSlice";
import { setCredentials } from "application/features/clientAuth/authClientSlice";
import Checkbox from "shared/Checkbox/Checkbox";
import InputPsw from "shared/InputPsw/InputPsw";
import { useTranslation } from "react-i18next";

export interface PageSignUpClientProps {
  className?: string;
}

const PageSignUpClient: FC<PageSignUpClientProps> = ({ className = "" }) => {

  const { t, ready } = useTranslation("translation");

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPasword, setConfirmPassword] = useState('');
  const [otp, setOtp] = useState('');
  const [error, setError] = useState('');
  const [agree, setAgree] = useState(false);

  const [loginClient, { isLoading: isLoginLoading }] = useLoginClientMutation();
  const [registerClient, { isLoading: isRegisterLoading }] = useRegisterClientMutation();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showOtp, setShowOtp] = useState(false);


  const handleLogin = async (e: any) => {
    e.preventDefault();
    try {
      const loginReponse = await loginClient({ email, password, otp_code: otp }).unwrap()
      dispatch(setCredentials({ ...loginReponse }))
      if (!loginReponse.error) {
        navigate("/client/")
        localStorage.setItem('client_token', loginReponse.token)
      }
    } catch (error: any) {
      if (!error?.data) {
        setError("Nessuna connessione al server")
      } else {
        setError("Email o password sbagliata")
      }
    }
  }

  const onFormSubmit = async (e: any) => {
    e.preventDefault();
    try {
      if (!email || !password) {
        setError("Inserisci email e password")
        return
      }
      if (password !== confirmPasword) {
        setError("Le password non coincidono")
        return
      }
      const signUpClientResponse = await registerClient({ email, password }).unwrap()
      setError('')
      setShowOtp(true);
    } catch (error: any) {
      if (!error?.data) {
        setError("Nessuna connessione al server")
      } else if (error?.status === 412) {
        setError("Email già registrata")
      } else {
        setError("Errore nella registrazione")
      }
    }
  }

  const handleSetEmail = (email: string) => {
    // trim email
    setEmail(email.trim());
  }

  if (!ready) return null;

  return (
    <div className={`nc-PageSignUp  ${className}`} data-nc-id="PageSignUp">
      <Helmet>
        <title>{t("translation:userRegister.title")} || TRIBYOU</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32">
        <div className="max-w-md mx-auto space-y-6 ">
          {/* FORM */}

          {!showOtp ?

            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                {t("translation:userRegister.heading")}
              </h2>
              <form className="grid grid-cols-1 gap-6" onSubmit={onFormSubmit} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                  {t("translation:userRegister.form.email")}
                  </span>
                  <Input
                    onChange={(e) => handleSetEmail(e.target.value)}
                    type="email"
                    placeholder="address@example.com"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    {t("translation:userRegister.form.password")}
                  </span>
                  <InputPsw
                    onChange={(e) => setPassword(e.target.value)}
                    type="password"
                    className="mt-1"
                  />
                </label>
                <label className="block">
                  <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                    {t("translation:userRegister.form.confirmPassword")}
                  </span>
                  <InputPsw
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    type="password"
                    className="mt-1"
                  />
                </label>
                <label className="flex flex-row items-center gap-3">
                  <Checkbox
                    className="mt-1"
                    name="agree"
                    isChecked={agree}
                    onChange={(e) => setAgree(e)}
                  />
                  <span className="text-neutral-800 dark:text-neutral-200">
                    {t("translation:userRegister.form.terms")}
                  </span>
                </label>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary
                  type="submit"
                  loading={isRegisterLoading}
                  disabled={!agree}
                >
                  {t("translation:userRegister.form.registerButton")}
                </ButtonPrimary>
              </form>

              {/* ==== */}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                {t("translation:userRegister.loginLink.text")}{` `}<Link to="/login-client">{t("translation:userRegister.loginLink.linkText")}</Link>
              </span>
            </>
            :
            <>
              <h2 className="my-20 flex items-center text-3xl leading-[115%] md:text-5xl md:leading-[115%] font-semibold text-neutral-900 dark:text-neutral-100 justify-center">
                {t("translation:userRegister.otpSection.heading")}
              </h2>
              <p className="mt-2 text-neutral-800">
                {t("translation:userRegister.otpSection.description")}<span className="font-semibold"> {email}</span>
              </p>
              <form className="grid grid-cols-1 gap-6" onSubmit={handleLogin} method="post">
                <label className="block">
                  <span className="text-neutral-800 dark:text-neutral-200">
                    {t("translation:userRegister.otpSection.codeLabel")}
                  </span>
                  <Input
                    onChange={(e) => setOtp(e.target.value)}
                    type="text"
                    placeholder="123456"
                    className="mt-1"
                  />
                </label>
                {error && <span className="text-red-500">{error}</span>}
                <ButtonPrimary type="submit" loading={isLoginLoading}>{t("translation:userRegister.otpSection.sendCodeButton")}</ButtonPrimary>
              </form>

              {/* ==== TODO: Fix the missing href*/}
              <span className="block text-center text-neutral-700 dark:text-neutral-300">
                {t("translation:userRegister.otpSection.resendMessage")}{` `}<Link className="text-red-500" to="#">{t("translation:userRegister.otpSection.resendButton")}</Link>
              </span>
            </>
          }

        </div>
      </div>
    </div>
  );
};

export default PageSignUpClient;
